// export const url = 'http://localhost:9000';
// export const url = 'http://localhost:8000/metapi';
// export const url = 'http://nawashalawa.com';
// export const url = 'http://3.6.92.130:9000';
export const url = 'https://metaspace.edu.lk/metapi';
// export const url = 'http://localhost:8008/metapi';
